import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import { ProsumerDeclarationState } from './types';

export const actions: ActionTree<ProsumerDeclarationState, RootState> = {
  reset({ commit }) {
    commit('identification/CLEAR')
    commit('contactInfo/CLEAR')
    commit('RESET')
  }
}
